import React from "react";

import { styled } from "@mui/material";

interface CloseButtonProps {
  onClick: () => void;
}

export const CloseButton = ({ onClick }: CloseButtonProps) => {
  return (
    <Container className={"ig-message-box-close"}>
      <Icon
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 25 25"
        data-testid="CloseIcon"
        height="18px"
        stroke="#CBDCD8"
        fill="#CBDCD8"
        onClick={onClick}
      >
        <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
      </Icon>
    </Container>
  );
};

const Container = styled("div")({
  width: "25px",
});

const Icon = styled("svg")({
  position: "absolute",
  left: "calc(100% - 28px)",
  top: 10,
  "&:hover": {
    cursor: "pointer",
  },
  "&:focus": {
    cursor: "pointer",
  },
});
